export const PROPERTY_SECTION_KEYS = {
  PROPERTY_DISPOSITION: "property-disposition",

  GENERAL_INFORMATION: "general-information",
  PROPERTY_FINANCIALS: "property-financials",
  PROPERTY_DETAILS: "property-details",
  LOCATION: "location",
  PROPERTY_RENT_ROLLS: "property-rent-rolls",

  PROPERTY_HISTORY: "property-history",

  INDIVIDUAL_OWNERS: "individual-owners",
  COMPANY_OWNERS: "company-owners",
  NEW_PROPERTY: "new-property",
  PROJECTION_VARIABLES: "projection-variables"
};

export const getTitleGroup = sectionKey => {
  switch (sectionKey) {
    case PROPERTY_SECTION_KEYS.GENERAL_INFORMATION:
      return ({
        title: "General Information",
        key: PROPERTY_SECTION_KEYS.GENERAL_INFORMATION,
        isTitleGroup: true
      });
  }
};
